import React from "react"
import { BsDot } from "react-icons/bs"
import BackToTopBtn from './BackToTopBtn'

const TarkemmatTiedot = ({ setCarInfo }) => {



    return (
        <div className="divEhdot">
            <h1 className="titleName">TARKEMMAT TIEDOT JA VARUSTELUT</h1>
            <br />
            <div className="flexbox-container">
                <div className="flexbox-item">
                    <h5>Hobby Optima T65 HKM ONTOUR</h5>
                    <h5>Tyypi: Matkailuauto</h5>
                    <h5>Korimalli: Puoli-integroitu</h5>
                    <h5>Vuosimalli: 2021</h5>
                    <h5>Rekisteritunnus: SYZ-287</h5>
                    <h5>Alusvalmistaja: Citroen</h5>
                    <h5>Moottori: 2,2 BlueHDI 140PS</h5>
                    <h5>Teho: 103 kw</h5>
                    <h5>Vetotapa: Etuveto</h5>
                    <h5>Vaihteisto: 6-v manuaalivaiteisto</h5>
                    <h5>Ovet: 3</h5>
                    <h5>Makuupaikat: 6</h5>
                    <h5>Pituus: 7000 mm</h5>
                    <h5>Leveys: 2330 mm</h5>
                    <h5>Korkeus: 2845 mm</h5>
                    <h5>Paino: 3500 kg</h5>
                    <h5>Vetokyky jarruilla: 2000 kg</h5>
                    <h5>Mittarilukema hetkellä: 9000 km</h5>
                    <br />
                    <h5><BsDot />ABS, lukkiutumattomat jarrut</h5>
                    <h5><BsDot />ESP sis. ASR, mäkilähtöavustin sekä HDC</h5>
                    <h5><BsDot />Renkaiden ilmanpaineiden seurantajärjestelmä</h5>
                    <h5><BsDot />Renkaanpaikkaussarja</h5>
                    <h5><BsDot />Roiskeläpät edessä ja takana</h5>
                    <h5><BsDot />Sähkötoimisesti säätyvät ja lämmitettävät ulkopeilit</h5>
                    <h5><BsDot />Pidennetyt ulkopeilit</h5>
                    <h5><BsDot />Sähkötoimiset ohjaamon ikkunat (vasen, oikea)</h5>
                    <h5><BsDot />Etupuskuri sekä ohjaamon ovenkahvat auton väriset</h5>
                    <h5><BsDot />Varoituskolmio ja ensiapupakkaus</h5>
                    <h5><BsDot />Ajotietokone</h5>
                    <br />
                    <h5><BsDot />Polttoainesäiliö: 90 litraa</h5>
                    <h5><BsDot />AdBlue-säiliö: 20 l</h5>
                    <br />
                    <h5><BsDot />Vakionopeudensäädin</h5>
                    <h5><BsDot />Käynnistyksenesto</h5>
                    <h5><BsDot />Keskuslukitus kaukosäädöllä</h5>
                    <h5><BsDot />Ohjaamon ilmastointilaite, manuaalinen, siitepölysuodattimella</h5>
                    <h5><BsDot />Kuljettajan ja etumatkustajan turvatyynyt</h5>
                    <h5><BsDot />Radioantenni integroitu kattoalueelle</h5>
                    <h5><BsDot />Navigaatiojärjestelmä DAB+, sis. CD/DVD soittimen ja leiripaikkatiedostot</h5>
                    <h5><BsDot />Peruutuskamera</h5>
                    <br />
                    <h5><BsDot />Takatallin luukku ulko-oven puoleisella seinällä</h5>
                    <h5><BsDot />Takatallin luukku kuljettajan puoleisella seinällä</h5>
                    <h5><BsDot />Alaslaskettu perä, jossa XPS-eristys</h5>
                    <h5><BsDot />Eristetty ja lämmitettävä takatavaratila jossa tukeva lattiapäällyste</h5>
                    <h5><BsDot />Valaistu tavaratila</h5>
                    <h5><BsDot />Kiinnityskiskot ja -silmukat tavaratilassa</h5>
                    <h5><BsDot />Kattoikkuna, avattava, kaksinkertainen ja sävytetty:</h5>
                    <div className='leftText'>
                        <h5> - DOMETIC-SEITZ Mini-Heki-kattoikkuna asuintilassa, 400 x 400 mm, pimennys- ja hyttyssuojalaskosverho</h5>
                        <h5> - DOMETIC-SEITZ Mini-Heki-kattoikkuna makuu-tilassa, 400 x 400 mm, pimennys- ja hyönteissuojaverho</h5>
                        <h5> - DOMETIC-SEITZ Mini-Heki-kattoikkuna pesuhuoneessa, 400 x 400 mm, pimennys- ja hyönteissuojaverho</h5>
                    </div>
                    <br />
                    <h5><BsDot />Yksiosainen erikoisleveä ulko-ovi jossa yksinkertainen lukitus (aukon mitat 605 x 1.740 mm)</h5>
                    <h5><BsDot />Ulko-ovessa hyönteissuojaverho</h5>
                    <h5><BsDot />Kädensija</h5>
                    <h5><BsDot />Sähkötoiminen ulkoporras</h5>
                    <h5><BsDot />LED-valo sisääntulossa</h5>
                    <h5><BsDot />Lasikuitulattia, XPS-lämpöeristys</h5>
                    <h5><BsDot />Lasikuitukatto raesuojalla</h5>
                    <h5><BsDot />Ulosvedettävä kaasupulloteline, 2 x 11 kg pulloille</h5>
                    <h5><BsDot />THULE-OMNISTOR 400 x 250 cm markiisi</h5>
                    <h5><BsDot />Ajokiilat auton tasaamiseksi</h5>
                    <h5><BsDot />Pyöräteline 4 pyörälle, max. 60kg</h5>
                    <h5><BsDot />Savuhälytin</h5>
                    <h5><BsDot />Invertteri 2500 W (Invertterin avulla voidaan muuntaa 12 V tasavirtajännite 230 V vaihtovirtajännitteeksi eli perus pistorasian sähköksi.)</h5>
                </div>
                <div className="flexbox-item">
                    <h5><BsDot />Aurinkopaneelijärjestelmä (lataa hupiakkua)</h5>
                    <br />
                    <h5><BsDot />Smart TV, 12 V / 230 V sähköpistorasia ja antennipistorasia</h5>
                    <h5><BsDot />USB kaksoispistorasiat asuin- ja makuutilassa</h5>
                    <h5><BsDot />Jääkaappi DOMETIC, 133 litraa, kaksoiskahvalla</h5>
                    <h5><BsDot />Sälepohjajärjestelmä GOODSIDE®, sis. kylmävaahtopatja(t)</h5>
                    <h5><BsDot />Kalusteet Cocobolo / Piquet Grau (harmaa)</h5>
                    <h5><BsDot />Kangasyhdistelmät Arras</h5>
                    <h5><BsDot />Suihkuvarustus, suihkutangossa säilytystilaa</h5>
                    <h5><BsDot />Käännettävä THETFORD wc-istuin</h5>
                    <h5><BsDot />Lämminvesijärjestelmä keittiössä ja pesuhuoneessa</h5>
                    <h5><BsDot />Talvi-ilmankierto istuinryhmässä, kaapeissa ja vuoteissa</h5>
                    <h5><BsDot />Jäätymiseltä suojatut asennukset lattiarakenteessa</h5>
                    <h5><BsDot />Lattialämmitys</h5>
                    <br />
                    <h5><BsDot />Harmaavesisäiliö: 96 l, eristetty ja lämmitettävä</h5>
                    <h5><BsDot />Käyttövesisäiliö: 10/ 100-l, suojattu jäätymiseltä</h5>
                    <h5><BsDot />Asuinosan akku AGM 12 V / 95 Ah</h5>
                    <h5><BsDot />Kaasuventtiili ylipainesuojalla (DIN EN 12 864) ja kaasuletku</h5>
                    <h5><BsDot />TRUMA Combi 6 E sähkövastuksin -lämmitys sis. 10 ltr lämminvesisäiliön ja pakkasvahtiventtiilin</h5>
                    <h5><BsDot />Ohjauspaneeli TRUMA Plus LCD Ohjauspaneeli</h5>
                    <br />
                    <h5><BsDot />Ohjaamoistuimet kyynärnojilla "Captains Chair", korkeussäädettävät</h5>
                    <h5><BsDot />Ohjaamon istuimet verhoiltu alkuperäisellä CITROËN-kankaalla</h5>
                    <h5><BsDot />Lannevyöt selkä menosuuntaan matkustavilla</h5>
                    <h5><BsDot />Valaistuksen ohjaus vuodetilasta</h5>
                    <h5><BsDot />Lisäpatjat vuoteen muodostamiseksi istuinryhmästä</h5>
                    <h5><BsDot />Kattovalot ja tunnelmavalaistus - LED</h5>
                    <br />
                    <h5><BsDot />Talvipaketti, sopii hyvin myös talvikelein.</h5>
                    <h5><BsDot />Ohjaamoon lämpöpeite</h5>
                    <br />
                    <input className="backTiedotBtn" type='button' value='Takaisin' onClick={() => setCarInfo(false)} />
                    <BackToTopBtn/>
                </div>
            </div>
        </div>
    )
}

export default TarkemmatTiedot